import styled from 'styled-components';

export const StyledContainer = styled.div`
  background: #fff;
  box-sizing: border-box;
`;
